import React from "react";
import Cx from "classnames";
import Draggable from "draggable";

import styles from "./styles.scss";
import { activatePopup } from "../helpers.js";

export default class ImageActions extends React.Component {
  state = {
    open: false,
  };

  convertImages = (convert_to_many = true) => {
    if (!window.finishedUploading()) {
      alert(
        "Please wait until all images have finished uploading before using this feature."
      );
      return;
    }

    const ids = this.props.items
      .filter((i) => i.selected)
      .map((item) => item.id);
    const currentId = window.location.pathname.split("/").reverse()[0];
    const convertToAWork = convert_to_many ? "" : "_to_a_work";
    const warning = convert_to_many
      ? `Are you sure you want to make new works for each selected image?`
      : `Are you sure you want to create a new work with all the selected images?`;

    setTimeout(() => {
      if (confirm(warning)) {
        $.ajax(`/projects/${currentId}/convert_images${convertToAWork}`, {
          method: "POST",
          data: {
            custom_files: { image: ids },
          },
        }).done((data) => {
          location.reload();
        });
      }
    }, 200);
  };

  moveImages = () => {
    if (!window.finishedUploading()) {
      alert(
        "Please wait until all images have finished uploading before using this feature."
      );
      return;
    }

    const { items, recordId, recordType, archivedItems, onImageAction } =
      this.props;
    const ids = items.filter((i) => i.selected).map((item) => item.id);
    const message =
      "Move the selected images to a work or project.\n\nEnter the unique id, for example P1020 for a project or w1230 for a work.";
    const uniqueId = prompt(message);
    const matched = uniqueId.toLowerCase().match(/^\s*([a-z])(\d+)\s*$/);

    if (matched) {
      const types = {
        p: "project",
        w: "work",
      };
      const recipientType = types[matched[1]];
      const recipientId = matched[2];

      $.ajax(`/move_images`, {
        method: "POST",
        data: {
          ids,
          fromType: recordType,
          fromId: recordId,
          recipientType,
          recipientId,
        },
      })
        .done((data) => {
          console.log("data", data);
          const message =
            data.message || `Succesfully moved ${ids.length} images`;

          onImageAction(
            items.filter((item) => !ids.includes(item.id)),
            archivedItems
          );

          // delay alert to esnure that onImageAction sends update to server
          setTimeout(() => {
            alert(message);
          }, 600);
        })
        .fail((data) => {
          alert(
            "The attempt to move images failed. Please contact an administrator."
          );
        });
    } else {
      alert(
        "Invalid unique id. Please enter a valid unique id, for example p1234 for a project or W1230 for a work."
      );
    }
  };

  makePrimary = () => {
    const { items, archivedItems, onImageAction } = this.props;
    const selected = items.filter((item) => item.selected);

    if (selected.length === 1) {
      onImageAction(
        items.map((item) => {
          console.log("item.selected", item.selected);
          console.log("item.isPrimary", item.isPrimary);
          return {
            ...item,
            isPrimary: !!item.selected,
          };
        }),
        archivedItems
      );
    }
  };

  popup = (e) => {
    const { items } = this.props;
    const index = items.findIndex((i) => i.selected);

    activatePopup(items, index);
    setTimeout(() => {
      this.setState({ open: false });
    }, 100);
  };

  editLink = (e) => {
    const { items } = this.props;
    const image = items.filter((i) => i.selected)[0];

    window.open(`/images/${image.id}`);

    setTimeout(() => {
      this.setState({ open: false });
    }, 100);
  };

  downloadOriginal = (e) => {
    e.preventDefault();
    const originalUrl = this.props.items
      .filter((item) => item.selected)
      .map((i) => i.original)[0];

    if (originalUrl.length) window.open(originalUrl, "_blank");
  };

  close = () => {
    this.setState({ open: false });
    this.props.onToggleFullscreen(false);
  };

  handleUndo = () => {
    this.props.onUndo();
  };

  handleClickOutside = (event) => {
    const ref = this.props.uploaderRef;

    if (!(ref && ref.contains(event.target))) {
      // not sure why this needs to be delayed
      setTimeout(() => {
        this.close();
      }, 200);
    }
  };

  onZoomIn = () => {
    this.props.onZoomIn();
  };

  onZoomOut = () => {
    this.props.onZoomOut();
  };

  removeItem = () => {
    const { items, archivedItems } = this.props;
    const itemsToRemove = items.filter((i) => i.selected);
    const itemIdsToRemove = itemsToRemove.map((i) => i.id);

    setTimeout(() => {
      const remainingItems = items.filter(
        (i) => !itemIdsToRemove.includes(i.id)
      );
      const archivedItemsNew = archivedItems.concat(itemsToRemove).map((i) => {
        let item = i;
        item.selected = false;
        return item;
      });

      this.props.onImageAction(remainingItems, archivedItemsNew);
      this.setState({ open: false });
    }, 200);
  };

  componentDidUpdate(prevProps) {
    const hasSelectedItems = this.props.items.filter(
      (item) => item.selected
    ).length;
    if (hasSelectedItems && !this.state.open) this.setState({ open: true });

    if (this._el) {
      if (prevProps.isFullscreen !== this.props.isFullscreen) {
        this._el.style.left = "";
      }
      this._el.style.height = "";
      this._el.style.width = "";
      this._el.style.transform = "";
      this._draggable = new Draggable(this._el, { handle: this._handle });
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const selectedItems = this.props.items.filter((item) => item.selected);
    // disable the remove button if any images from the project's works are
    // selected, because those can only be remove from the work
    const workImagesSelected =
      selectedItems.length && selectedItems.filter((i) => i.isWorkImage).length;
    const isNewProject =
      window.location.pathname.split("/").reverse()[0] == "new";

    if (!this.state.open) return <div />;

    return (
      <ul
        className={Cx(styles.actions, {
          [styles.isFullscreen]: this.props.isFullscreen,
        })}
        ref={(c) => {
          this._el = c;
        }}
      >
        <li
          className={styles.handle}
          ref={(c) => {
            this._handle = c;
          }}
        >
          <span />
        </li>
        <li
          className={Cx({
            [styles.disabled]:
              selectedItems.length !== 1 ||
              selectedItems[0].isPrimary ||
              isNewProject,
          })}
          onMouseDown={this.makePrimary}
        >
          Make primary
        </li>
        <li
          className={Cx({ [styles.disabled]: !selectedItems.length })}
          onMouseDown={this.popup}
        >
          Slideshow View
        </li>
        <li
          className={Cx({ [styles.disabled]: !selectedItems.length })}
          onMouseDown={this.editLink}
        >
          Edit ✍️
        </li>
        <li
          className={Cx({ [styles.disabled]: !selectedItems.length })}
          onMouseDown={this.downloadOriginal}
        >
          Download Original
        </li>
        {this.props.recordType === "project" && (
          <>
            <li
              className={Cx({
                [styles.disabled]:
                  workImagesSelected || !selectedItems.length || isNewProject,
              })}
              onMouseDown={this.convertImages}
            >
              Convert to Works ♻️
            </li>
            <li
              className={Cx({
                [styles.disabled]:
                  workImagesSelected || !selectedItems.length || isNewProject,
              })}
              onMouseDown={() => this.convertImages(false)}
            >
              Convert to a Work ♻️
            </li>
            <li
              className={Cx({
                [styles.disabled]:
                  workImagesSelected || !selectedItems.length || isNewProject,
              })}
              onMouseDown={this.moveImages}
            >
              Move 🏹
            </li>
          </>
        )}
        <li
          className={Cx(styles.remove, {
            [styles.disabled]: workImagesSelected || !selectedItems.length,
          })}
          onMouseDown={this.removeItem}
        >
          Archive ❌
        </li>
        <li onMouseDown={this.handleUndo}>Undo</li>
        <li onClick={this.props.onToggleFullscreen}>Fullscreen</li>
        <li className={styles.zoomButtons}>
          Zoom <span onClick={this.props.onZoomIn}>+</span>{" "}
          <span onClick={this.props.onZoomOut}>-</span>
        </li>
        <li onClick={this.close}>Close</li>
      </ul>
    );
  }
}
